import {ElementMixin} from '@polymer/polymer/lib/mixins/element-mixin';
import {dedupingMixin} from '@polymer/polymer/lib/utils/mixin.js';

export const RecursiveValidate = dedupingMixin(superClass => {
  return class extends ElementMixin(superClass) {
    /**
     * Returns all nodes in this DOM tree that have a validate() method
     * and are not disabled
     *
     * @returns {Array}
     * @private
     */
    _getValidatableElements() {
      let descendants = this.root.querySelectorAll('*');

      let ret = [];
      for( let node of descendants ) {
        if( !node.disabled && typeof node.validate === 'function' ) {
          ret.push(node);
        }
      }

      return ret;
    }

    /**
     * Validates that an entity and a relationship are selected if the
     * 'required' property is true
     *
     * @returns {boolean}
     */
    validate() {
      if( this.disabled ) {
        return true;
      }

      return this._getValidatableElements().every(element => {
        return element.validate();
      });
    }
  };
});

